import React from "react";
import { Link } from "react-router-dom";
import { FaPaperPlane, FaPaperclip, FaArrowLeft, FaTimes } from "react-icons/fa";
import { connect } from "react-redux";
import { Translate, I18n } from "react-redux-i18n";
import alertify from "alertifyjs";

import "./styles/Chat.css";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

import MessageList from "../components/MessageList";
import PanelLayout from "../components/PanelLayout";
import { ListSkeleton } from "../components/Skeleton";

import * as actions_message from "../redux/actions/messageActions";
import * as actions_event from "../redux/actions/eventActions";
import * as actions_contacts from "../redux/actions/contactsActions";
import * as actions_notification from "../redux/actions/notificationActions";
import Typping from "../components/Typping";
import ModalGodiwayer from "../components/ModalGodiwayer";
import { convertToWebp } from "../utils/imageUtils";

const CHAT_FILE_ACCEPT =
  "image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip";
const CHAT_MAX_FILE_SIZE = 10 * 1024 * 1024;

var timer;

function isImageFile(file) {
  return (file?.type || "").startsWith("image/");
}

class Chat extends React.Component {
  state = {
    message: "",
    open_modal: false,
    file: null,
    filePreview: "",
    fileName: "",
    hasFile: false,
    sending: false,
  };

  fileInputRef = React.createRef();

  componentDidMount() {
    if (this.props.contact && this.props.contact.UserId) {
      this.props.SetContactMessage(this.props.contact);
    }
    this.fetchMessageList();
  }

  componentDidUpdate() {
    this.scrollToBottom();
  }

  componentWillUnmount() {
    this.props.ClearContactMessage();
    this.props.ClearContactEvent();
    this.props.ClearContact();
    clearInterval(timer);
  }

  fetchMessageList = async () => {
    try {
      await this.props
        .LoadMessages(this.props.token, {
          conversation_id: this.props.match.params.conversation_id,
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            console.log(this.props.error);
          }
        });
    } catch (error) {
      console.log(error);
    }
    this.scrollToBottom();
  };

  scrollToBottom = () => {
    const element = document.getElementById("scroll_chat");
    if (element !== null) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  clearAttachment = () => {
    this.setState({
      file: null,
      filePreview: "",
      fileName: "",
      hasFile: false,
    });
    if (this.fileInputRef.current) {
      this.fileInputRef.current.value = "";
    }
  };

  onClickAttach = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  onChangeFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (file.size > CHAT_MAX_FILE_SIZE) {
      alertify.warning(I18n.t("chat_file_too_large"));
      event.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      this.setState({
        file,
        filePreview: isImageFile(file) ? reader.result : "",
        fileName: file.name,
        hasFile: true,
      });
    };

    if (isImageFile(file)) {
      reader.readAsDataURL(file);
    } else {
      this.setState({
        file,
        filePreview: "",
        fileName: file.name,
        hasFile: true,
      });
    }
  };

  buildOptimisticMessage = (text, fileMeta = {}) => {
    return {
      id: this.props.pageCount + 1,
      text,
      file_url: fileMeta.file_url || "",
      file_name: fileMeta.file_name || "",
      file_type: fileMeta.file_type || "",
      created_at: new Date(),
      conversation_id: this.props.contact.ConversationId,
      to_id: this.props.contact.UserId,
      is_server: 2,
      is_seen: 2,
      user: {
        id: this.props.auth.id,
        name: this.props.auth.name,
        lastN: this.props.auth.lastN,
        avatar: this.props.auth.avatar,
      },
      socket: this.props.contact.Socket,
      lang: I18n.t("locale"),
    };
  };

  onClickSendMessage = async () => {
    const text = this.state.message.trim();
    const { file, hasFile, sending } = this.state;

    if (sending || (!text && !hasFile)) return;

    const index = this.props.pageCount + 1;
    const fileType = file && isImageFile(file) ? "image" : "file";

    try {
      this.setState({ sending: true });

      const optimisticMessage = this.buildOptimisticMessage(text, {
        file_url: this.state.filePreview,
        file_name: this.state.fileName,
        file_type: hasFile ? fileType : "",
      });

      this.props.AddMessage(this.props.token, optimisticMessage);

      let storedMessage = null;

      if (hasFile && file) {
        const uploadFile = isImageFile(file) ? await convertToWebp(file) : file;
        const params = new FormData();
        params.append("file", uploadFile);
        params.append("id", this.props.user_id);
        params.append("conversation_id", this.props.contact.ConversationId);
        params.append("socket", this.props.contact.Socket || "");
        params.append("lang", I18n.t("locale"));
        if (text) {
          params.append("text", text);
        }

        storedMessage = await this.props.StoreMessage(
          this.props.token,
          params,
          index
        );
      } else {
        const params = {
          id: this.props.user_id,
          text,
          conversation_id: this.props.contact.ConversationId,
          to_id: this.props.contact.UserId,
          is_server: 2,
          is_seen: 2,
          user: optimisticMessage.user,
          socket: this.props.contact.Socket,
          lang: I18n.t("locale"),
        };

        storedMessage = await this.props.StoreMessage(
          this.props.token,
          params,
          index
        );
      }

      if (!this.props.error && storedMessage) {
        this.props.SendMessage(storedMessage);
      } else if (this.props.error) {
        alertify.warning(I18n.t(this.props.error));
      }

      this.setState({
        message: "",
        sending: false,
      });
      this.clearAttachment();

      clearInterval(timer);
      timer = setTimeout(() => {
        this.scrollToBottom();
      }, 100);
    } catch (error) {
      console.log(error);
      this.setState({ sending: false });
      alertify.warning(I18n.t("try_later"));
    }
  };

  onChange = (event) => {
    this.setState({ message: event.target.value });
    if (
      this.props.contact.Socket != undefined &&
      this.props.contact.Socket !== ""
    ) {
      this.props.SendEvent({
        socket: this.props.contact.Socket,
        status: "typingOn",
        id: this.props.user_id,
      });
    }
  };

  onKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.onClickSendMessage();
    }
  };

  seeModal = () => {
    this.setState({ open_modal: true });
  };

  onClose = () => {
    this.setState({ open_modal: false });
  };

  render() {
    const { contact, onLine, event, messageList, loading } = this.props;
    const { message, hasFile, filePreview, fileName, sending } = this.state;
    const contactName = `${contact.Name || ""} ${contact.LastN || ""}`.trim();
    const isTyping = event.status === "typingOn";
    const canSend = (message.trim().length > 0 || hasFile) && !sending;

    return (
      <React.Fragment>
        <PanelLayout>
          <div className="chat-page">
            <header className="chat-page__header">
              <Link
                to="/contacts"
                className="chat-page__back"
                aria-label={I18n.t("contact_title")}
              >
                <FaArrowLeft />
              </Link>

              <div className="chat-page__avatar-wrap">
                <button
                  type="button"
                  className="chat-page__avatar-btn"
                  onClick={this.seeModal}
                  aria-label={contactName}
                >
                  <img
                    src={contact.Avatar}
                    className="chat-page__avatar"
                    alt=""
                  />
                </button>
                {onLine !== "" && <span className="chat-page__online" />}
              </div>

              <div className="chat-page__contact">
                <button
                  type="button"
                  className="chat-page__name"
                  onClick={this.seeModal}
                >
                  {contactName}
                </button>
                <div className="chat-page__meta">
                  {isTyping ? (
                    <Typping background="light" kind="scaling" />
                  ) : (
                    <span>
                      <Translate value="message_count" />: {messageList.length}
                    </span>
                  )}
                </div>
              </div>
            </header>

            <div
              className={`chat-page__messages${
                loading ? " chat-page__messages--loading" : ""
              }`}
            >
              {loading ? <ListSkeleton count={4} /> : <MessageList />}
              <div className="chat-page__scroll-anchor" id="scroll_chat" />
            </div>

            {hasFile && (
              <div className="chat-page__attachment-preview">
                {filePreview ? (
                  <img
                    src={filePreview}
                    alt=""
                    className="chat-page__attachment-image"
                  />
                ) : (
                  <span className="chat-page__attachment-name">{fileName}</span>
                )}
                <button
                  type="button"
                  className="chat-page__attachment-remove"
                  onClick={this.clearAttachment}
                  aria-label={I18n.t("delete")}
                >
                  <FaTimes />
                </button>
              </div>
            )}

            <div className="chat-page__composer">
              <input
                ref={this.fileInputRef}
                type="file"
                id="chat_attach_input"
                className="chat-page__attach-input"
                accept={CHAT_FILE_ACCEPT}
                onChange={this.onChangeFile}
              />
              <button
                type="button"
                className="chat-page__attach"
                onClick={this.onClickAttach}
                disabled={sending}
                aria-label={I18n.t("chat_attach_file")}
              >
                <FaPaperclip />
              </button>
              <textarea
                name="message"
                className="chat-page__input"
                placeholder={I18n.t("chat_message_placeholder")}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
                value={message}
                rows={1}
                disabled={sending}
              />
              <button
                type="button"
                className="chat-page__send"
                onClick={this.onClickSendMessage}
                disabled={!canSend}
                aria-label={I18n.t("message")}
              >
                <FaPaperPlane />
              </button>
            </div>
          </div>
        </PanelLayout>
        <ModalGodiwayer
          isOpen={this.state.open_modal}
          onClose={this.onClose}
          item={contact}
          showChatAction={false}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    auth: reducer.session.auth,
    token: reducer.session.auth.access_token,
    user_id: reducer.session.auth.id,
    messageList: reducer.message.list,
    pageCount: reducer.message.page_count,
    error: reducer.message.error,
    loading: reducer.message.loading,
    messageServer: reducer.message.item,
    contact: reducer.contacts.item,
    onLine: reducer.contacts.online,
    event: reducer.event.event,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMessages: (token, params) =>
    dispatch(actions_message.loadList({ token, params })),
  AddMessage: (token, params) =>
    dispatch(actions_message.addMessage({ token, params })),
  StoreMessage: (token, params, index) =>
    dispatch(actions_message.newItem({ token, params, index })),
  ClearContactMessage: () =>
    dispatch(actions_message.clearContactMessage({})),
  SendMessage: (params) => dispatch(actions_event.sendMessage(params)),
  SendEvent: (params) => dispatch(actions_event.sendEvent(params)),
  ClearContactEvent: () => dispatch(actions_event.clearContactEvent()),
  ClearContact: () => dispatch(actions_contacts.clearContact()),
  SetContactMessage: (item) =>
    dispatch(actions_message.updateContactMessage(item)),
  SendNotification: (token, params) =>
    dispatch(actions_notification.sendNotification({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
